import ky from 'ky'
import {httpError} from '../utils/errors'

/**
 * UserService provides user API services
 */
class UserService {

    /**
     * patch applies a partial update to a user
     *
     * @param accountId
     * @param userId
     * @param patch
     * @returns {Promise<unknown>}
     */
    patch = (accountId, userId, patch) => {
        //console.log('UserService.patch() accountId:', accountId, 'userId', userId, 'patch=', patch)
        return new Promise((resolve, reject) => {
            const patchSet = {object: 'user', id: userId, properties: patch};
            const url = `/api/v2/accounts/${accountId}/users/${userId}`
            ky.patch(url, {json: patchSet})
                .then(result => resolve(result))
                .catch(error => httpError(error).then(er => reject(er)))
        })
    }

    /**
     * setPassword changes the user's password
     *
     * @param accountId
     * @param userId
     * @param password
     * @returns {Promise<unknown>}
     */
    setPassword = (accountId, userId, password) => {
        //console.log('UserService.patch() accountId:', accountId, 'userId', userId, 'password', password)
        return new Promise((resolve, reject) => {
            const request = {password};
            const url = `/api/v2/accounts/${accountId}/users/${userId}/password`
            ky.put(url, {json: request})
                .then(result => resolve(result))
                .catch(error => httpError(error).then(er => reject(er)))
        })
    }
}

// Create a singleton instance of the service to export
const instance = new UserService();

export default instance;